export default __webpack_public_path__ + "static/media/trophy.d97a7e4f.svg";